/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_link_minecraft_target_user = /** @type {(inputs: { username: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Target BeaconAuth Account: ${i?.username}`)
};

const zh_hans1_link_minecraft_target_user = /** @type {(inputs: { username: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`目标 BeaconAuth 账号：${i?.username}`)
};

const zh_hant1_link_minecraft_target_user = /** @type {(inputs: { username: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`目標 BeaconAuth 帳號：${i?.username}`)
};

const fr_link_minecraft_target_user = /** @type {(inputs: { username: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Compte BeaconAuth cible : ${i?.username}`)
};

const de_link_minecraft_target_user = /** @type {(inputs: { username: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ziel-BeaconAuth-Konto: ${i?.username}`)
};

const ja_link_minecraft_target_user = /** @type {(inputs: { username: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`連携先 BeaconAuth アカウント: ${i?.username}`)
};

const ko_link_minecraft_target_user = /** @type {(inputs: { username: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`연동할 BeaconAuth 계정: ${i?.username}`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ username: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const link_minecraft_target_user = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.link_minecraft_target_user(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("link_minecraft_target_user", locale)
	if (locale === "en") return en_link_minecraft_target_user(inputs)
	if (locale === "zh-Hans") return zh_hans1_link_minecraft_target_user(inputs)
	if (locale === "zh-Hant") return zh_hant1_link_minecraft_target_user(inputs)
	if (locale === "fr") return fr_link_minecraft_target_user(inputs)
	if (locale === "de") return de_link_minecraft_target_user(inputs)
	if (locale === "ja") return ja_link_minecraft_target_user(inputs)
	return ko_link_minecraft_target_user(inputs)
};